import Base from './Base';

export default Base;


// WEBPACK FOOTER //
// ./src/routes/index.js